var $ = require('jquery');
var common = require('./common');
require('matchmedia');

var self = {};

self.initialise = function ($pageNav) {
  $(document).ready(function () {
    var $header = $('header'),
      $pageNav = $('.page-navigation'),
      $pageNavItem = $('.page-navigation span'),
      sectionPadding = 40;

    var innerWidth = common.innerWidth();
    var headerHeight = innerWidth > 768 ? $header.height() + sectionPadding : $pageNav.height();
    var selectedItem = '';
    var sections = [];

    pageNavClick();
    getSections();
    if ($('.inxpress-country').length > 0) positionCarousel(false);

    $(window).scroll(function () {
      selectActiveItem();
      if ($('.inxpress-country').length > 0) positionCarousel(true);
    });

    $(window).resize(function () {
      innerWidth = common.innerWidth();
      headerHeight = innerWidth > 768 ? $header.height() + sectionPadding : $pageNav.height();
      pageNavClick();
      getSections();
      selectActiveItem();
      if ($('.inxpress-country').length > 0) positionCarousel(true);
    });

    function pageNavClick() {
      $('.page-navigation span').unbind();
      $('.page-navigation span').click(function () {
        var $this = $(this);
        var dataClass = $this.attr('data-class');
        if (dataClass.length > 0) {
          var $section = $('.' + dataClass);
          if ($section.length > 0) {
            $('html, body').animate(
              {
                scrollTop: $section.offset().top - headerHeight,
              },
              1000
            );
          }
        }
      });
    }

    function getSections() {
      selectedItem = '';
      sections = [];

      $('[class^="pnav-"]').each(function () {
        var $this = $(this);
        sections.push({
          class: $this.attr('class'),
          top: $this.offset().top - headerHeight - 5,
          bottom: $this.offset().top + $this.height() - headerHeight - 5,
        });
      });
    }

    function selectActiveItem() {
      var scrollTop = $(window).scrollTop();

      var whoKnows = $.grep(sections, function (e) {
        return parseFloat(e.top) <= scrollTop && parseFloat(e.bottom) > scrollTop;
      });

      if (whoKnows.length) {
        var item = whoKnows[0];
        if (item.class != selectedItem) {
          $pageNavItem.removeClass('active');
          $pageNavItem
            .parent()
            .find('[data-class="' + item.class + '"]')
            .addClass('active');
          selectedItem = item.class;
        }
      } else {
        $pageNavItem.removeClass('active');
        selectedItem = '';
      }
    }

    function positionCarousel(isScrollOrResize) {
      var $topBanner = $('.outer-div-indent');

      if ($('.site-country').length > 0 && $topBanner.length > 0) {
        var $infoBar = $('.info-bar');
        var $mainNav = $('header');
        var pageNavigation = $('.page-navigation-panel');
        var pageNavigationHeight = pageNavigation.length > 0 ? pageNavigation.outerHeight() : 0;

        if (matchMedia('(min-width: 769px)').matches) {
          if (isScrollOrResize)
            $topBanner.css('margin-top', $mainNav.outerHeight() + pageNavigationHeight);
          else
            $topBanner.css(
              'margin-top',
              $mainNav.outerHeight() + $infoBar.outerHeight() + pageNavigationHeight
            );
          return;
        }

        if (matchMedia('(min-width: 581px)').matches) {
          $topBanner.css('margin-top', $infoBar.outerHeight() + pageNavigationHeight);
          return;
        }

        if ($('header.animate-header').length > 0) {
          $topBanner.css('margin-top', $infoBar.outerHeight() + pageNavigationHeight);
        } else {
          $topBanner.css('margin-top', pageNavigationHeight);
        }
      }
    }

    var $account = $('.js-account');
    var $linkPanel = $('.main-navigation');
    var $infoBarLinks = $('.info-bar__links');
    function setAccountPosition() {
      if ($account.length) {
        var allocatedWidth = window.innerWidth;
        if (allocatedWidth <= 900) {
          if (allocatedWidth <= 769) {
            $linkPanel.show();
            $infoBarLinks.show();
          } else {
            $linkPanel.hide();
            $infoBarLinks.hide();
          }
        } else {
          $linkPanel.show();
          $infoBarLinks.show();
          allocatedWidth -= +$linkPanel.offset().left;
          allocatedWidth -= +$account.css('width').replace('px', '');
          allocatedWidth -= +$account.css('right').replace('px', '');
          $linkPanel.css('width', allocatedWidth);
        }
      }
    }
    $(window).resize(setAccountPosition);
    setAccountPosition();
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/pageNavigation.js